import React, { useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';

import ColorScheme from './colors';

export const WithTheme: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
	useEffect(() => {
		const stylesheet = document.querySelector('[data-preload-renderer=true]');
		if(stylesheet) stylesheet.remove();
	}, []);

	return (
		<CssVarsProvider theme={ColorScheme} defaultMode={'dark'}>
			<CssBaseline />
			{children}
		</CssVarsProvider>
	)
}

export default WithTheme;
